import { Container } from '@mui/material';
import React from 'react';

const SignInRequired = props => {
  return <Container><a href='/sign-in'>Sign In required</a></Container>
}

export default SignInRequired;